const checkMinHeight = () => {
    const allTeamViews = document.querySelectorAll('.ume-intra-staff-team-view');
    if (allTeamViews.length > 0) {
        allTeamViews.forEach(team => {
            const allNames = team.querySelectorAll('.staff-card-name');
            const allStaffCards = team.querySelectorAll('.ume-intra-staff-card');
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

            if (allStaffCards.length > 0 && vw > 649) {
                let sameObject = {};
                // Sort staff cards that have the same y position (are next to each other)
                allStaffCards.forEach(card => {
                    let yValue = card.getBoundingClientRect().y;
                    if (yValue in sameObject) {
                        sameObject[yValue].push(card);
                    }
                    if (!(yValue in sameObject)) {
                        sameObject[yValue] = [];
                        sameObject[yValue].push(card);
                    }
                })
                for (let key in sameObject) {
                    if (sameObject.hasOwnProperty(key) && Array.isArray(sameObject[key]) && sameObject[key].length > 1) {
                        let mHeight = 0;
                        sameObject[key].forEach(el => {
                            const name = el.querySelector('.staff-card-name');
                            let elementHeight = name.offsetHeight;
                            if (elementHeight > mHeight) {
                                mHeight = elementHeight;
                            }
                        })
                        if (mHeight > 0) {
                            sameObject[key].forEach(el => {
                                const name = el.querySelector('.staff-card-name');
                                name.style.minHeight = mHeight + 'px';
                            })
                        }
                    }
                }
            }

            if (allNames.length > 0 && vw < 650) {
                allNames.forEach(name => {
                    name.style.minHeight = '';
                })
            }
        })
    }
}
document.addEventListener('umeIntraReadyStateComplete', ev => {
    checkMinHeight();
})
document.addEventListener('umeIntraResized', ev => {
    checkMinHeight();
})